// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2707":"79e54b52","2947":"11b01132","7518":"0bb3b609","9902":"1e3b9c63"}[chunkId] + ".chunk.css";
};